var React = require('react');

function ShareTwitterInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"0.5","width":"52","height":"52","rx":"26","fill":"#131416","key":0}),React.createElement("path",{"d":"M34.5417 13.0498H39.0593L29.1896 24.3303L40.8005 39.6804H31.7093L24.5886 30.3706L16.441 39.6804H11.9206L22.4773 27.6147L11.3389 13.0498H20.661L27.0974 21.5593L34.5417 13.0498ZM32.9561 36.9764H35.4594L19.3007 15.6118H16.6145L32.9561 36.9764Z","fill":"white","key":1})]);
}

ShareTwitterInline.defaultProps = {"width":"52","height":"53","viewBox":"0 0 52 53","fill":"none","role":"img","aria-label":"twitter"};

module.exports = ShareTwitterInline;

ShareTwitterInline.default = ShareTwitterInline;
